<template>
  <Fab v-if="enabled" :icon="icon" @click="nav" />
</template>

<script>
import Fab from '@/components/Fab';

export default {
  name: 'NavigationFab',
  components: { Fab },
  props: {
    position: { type: String, default: 'top-left' },
    positionAlt: { type: String, default: 'none' }
  },
  created() {
    this.icon = this.$store.state.theme.navigationButtonIcon;
  },
  computed: {
    enabled() {
      if (this.position === 'show') return true;
      if (this.$store.state.theme.navigationButton === this.position) return true;
      if (this.$store.state.theme.navigationButton === this.positionAlt) return true;
      return false;
    }
  },
  methods: {
    nav() {
      const { navigation } = this.$store.state.ui;
      this.$store.commit('ui/navigation', !navigation);
    },
  }
};
</script>
